import { Alert, AlertIcon, AlertTitle, AlertDescription, Box, Button, Stack, Text } from "@chakra-ui/react";
import { EVENT_KIND_META, eventPeriod } from "../../calendarEvents/utils/calendarEventKinds";

// "2026-11-10" -> "10/11/2026" (o endpoint de conflitos devolve a data em ISO).
function formatIsoDate(iso) {
  const [ano, mes, dia] = (iso ?? "").split("-");
  return ano && mes && dia ? `${dia}/${mes}/${ano}` : iso;
}

// Compromisso: "Você marcou Férias de 10/11 a 20/11", "Você marcou Dentista em 12/11 às 14:00".
function describeCalendarEvent(conflito) {
  const nome = conflito.titulo || EVENT_KIND_META[conflito.compromisso_tipo]?.label || "um compromisso";
  return `Você marcou ${nome} ${eventPeriod({ data_inicio: conflito.data, data_fim: conflito.data_fim, hora_inicio: conflito.hora_inicio })}`;
}

function describeConflict(conflito) {
  if (conflito.tipo === "compromisso") return describeCalendarEvent(conflito);
  const hora = conflito.hora_inicio ? ` às ${conflito.hora_inicio}` : "";
  return `${formatIsoDate(conflito.data)}${hora} · ${conflito.horas}h · ${conflito.vinculo_nome}`;
}

function warningTitle(conflitos) {
  if (conflitos.some((c) => c.tipo === "compromisso")) return "Este horário bate com a sua agenda";
  return `Este horário bate com ${conflitos.length === 1 ? "outro plantão" : "outros plantões"}`;
}

// Aviso de conflito de horário mostrado no corpo do modal, no lugar do formulário. Lista
// plantões e compromissos (folga, férias, feriado, evento) que caem no mesmo horário.
export function ShiftConflictWarning({ conflitos }) {
  return (
    <Alert status="warning" variant="subtle" alignItems="flex-start" borderRadius="md">
      <AlertIcon />
      <Box>
        <AlertTitle>{warningTitle(conflitos)}</AlertTitle>
        <AlertDescription>
          <Stack spacing={1} mt={2}>
            {conflitos.map((conflito) => (
              <Text key={`${conflito.tipo}-${conflito.id}`} fontSize="sm">
                {describeConflict(conflito)}
              </Text>
            ))}
          </Stack>
        </AlertDescription>
      </Box>
    </Alert>
  );
}

// Rodapé do modal enquanto o aviso está aberto: o médico decide se salva mesmo assim.
export function ShiftConflictFooter({ onConfirm, onBack, confirmLabel = "Registrar mesmo assim", isSubmitting = false }) {
  return (
    <>
      <Button variant="ghost" onClick={onBack} isDisabled={isSubmitting}>
        Voltar
      </Button>
      {/* O variant solid do tema sempre pinta brand.500 (ignora colorScheme): a cor de
          alerta vai explícita, como no CancelShiftDialog. Parte do 600 porque o âmbar 500
          com texto branco não tem contraste suficiente. */}
      <Button
        bg="warning.600"
        color="white"
        _hover={{ bg: "warning.700" }}
        _active={{ bg: "warning.700" }}
        onClick={onConfirm}
        isLoading={isSubmitting}
      >
        {confirmLabel}
      </Button>
    </>
  );
}
